import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable} from "rxjs";

import {Vehicle} from "@commons/models/domain/Vehicle";
import {Driver} from "@commons/models/domain/Driver";

import {BaseService} from "@shared/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class NewDataStoreService extends BaseService {

  private vehiclesDict = new Map<number, Vehicle>();
  private driversDict = new Map<number, Driver>();
  private driversElectronicIdToDriverIdDict = new Map<string, number>();

  private readonly onDriversLoaded = new BehaviorSubject<Driver[]>([]);
  get driversLoaded(): Observable<Driver[]> {
    return this.onDriversLoaded;
  }

  private readonly onVehiclesLoaded = new BehaviorSubject<Vehicle[]>([]);
  get vehiclesLoaded(): Observable<Vehicle[]> {
    return this.onVehiclesLoaded;
  }

  constructor() {
    super();
  }

  saveVehicles(vehicles: Vehicle[]): void {
    this.vehiclesDict.clear();
    const clone = this.getClone(vehicles) as Vehicle[];
    clone.forEach(v => this.vehiclesDict.set(v.Id, v));

    this.onVehiclesLoaded.next(clone);
  }

  addOrUpdateVehicle(vehicle: Vehicle): void {
    const clone = this.getClone(vehicle);
    this.vehiclesDict.set(vehicle.Id, clone);
  }

  getVehicles(): Vehicle[] {
    return Array.from(this.vehiclesDict.values());
  }

  getVehicleById(vehicleId: number): Vehicle {
    return this.vehiclesDict.get(vehicleId) ?? new Vehicle();//TODO GB tymczasowo żeby nie zmianieć logiki starego kodu
  }

  saveDrivers(drivers: Driver[]): void {
    this.driversDict.clear();
    const clone = this.getClone(drivers) as Driver[];
    clone.forEach(d => {
      this.driversElectronicIdToDriverIdDict.set(d.EI, d.Id);
      this.driversDict.set(d.Id, d)
    });

    this.onDriversLoaded.next(drivers);
  }

  getDrivers(): Driver[] {
    return Array.from(this.driversDict.values());
  }

  getDriverById(driverId: number): Driver {
    return this.driversDict.get(driverId) ?? {} as Driver;//TODO GB tymczasowo żeby nie zmianieć logiki starego kodu
  }

  getDriverByElectronicId(electronicId: string): Driver {
    const driverId = this.driversElectronicIdToDriverIdDict.get(electronicId);
    return driverId ? this.driversDict.get(driverId)! : {} as Driver;//TODO GB tymczasowo żeby nie zmianieć logiki starego kodu
  }
}
